import React, { useState, useRef, useEffect, useContext } from 'react'
import { View, TouchableOpacity, StyleSheet, Image, Text } from 'react-native';
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

//import ReactPlayer from 'react-player/file'
import ReactPlayer from 'react-player/youtube'

import { fontColorWhite, shadowWhiteTxt, routeTop } from '../../../../../style/css/CmnStyle';
import { hpContext } from '../../../HPContext';


function HpTopHead() {
  const { t, i18n } = useTranslation();

  const navigate = useNavigate();

  const isWide = useContext(hpContext).isWide;
  const iosLink = useContext(hpContext).iosLink;
  const androidLink = useContext(hpContext).androidLink;

  const onClickIosDownload = useContext(hpContext).onClickIosDownload;
  const onClickAndroidDownload = useContext(hpContext).onClickAndroidDownload;

  // 動画
  const videoRef = useRef(null);
  const videoHeight = '56.25vw';
  //const dispUrl = 'https://youtu.be/F1cVTkzgv88';
  //const dispUrl = 'https://youtu.be/05Bjnh9eUJE';
  //const dispUrl = 'https://youtu.be/QwD6sI7TgNA';
  const dispUrl = 'https://youtu.be/AiWVZE-29WA';
  const [videoUrl, setVideoUrl] = useState(dispUrl);
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const [isPlayVideo, setIsPlayVideo] = useState(true);


  // 動画の読み込み確認:それまで画像表示
  const handleVideoReady = () => {
    setTimeout(() => {
      setIsVideoLoaded(true);
    }, 500);
  }


  // ブラウザを閉じて開くと再生されない:再生停止検出
  const onPause = () => {
    setIsPlayVideo(false);
  }


  // ブラウザを閉じて再度開いたときに動画が再生されない
  useEffect(() => {
    setInterval(() => {
      // なぜかif(!isPlayVideo)で判定できない
      //if(!isPlayVideo) { setIsPlayVideo(true); }
      setIsPlayVideo(true);
    }, 1000)
  }, []);


  const onPauseLogo = () => {
    navigate(routeTop);
  }



  const styles = StyleSheet.create({
    titleWrap: {
      position: 'absolute',
      top: '30%',
      left: '50%',
      transform: 'translateX(-50%) translateY(-50%)',
      flexDirection: 'row',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'center',
    },
    img: {
      objectFit: 'cover',
      width: isWide? '6vw' : '18vw',
      height: isWide? '6vw' : '18vw',
      borderRadius: 10,
      marginRight: isWide? 30 : 10,
    },
    title: {
      color: fontColorWhite,
      fontSize: isWide? '5rem' : '3rem',
      fontWeight: 'bold',
      textShadowColor: 'black',
      textShadowOffset: {width: 3, height: 2},
    },
  });

  return (
    <header id="header">


      <View style={styles.titleWrap}>
        <TouchableOpacity onPress={onPauseLogo}>
          <img
            src='./assets/img/logo.png'
            style={styles.img}
            alt='InspireMe'
          />
        </TouchableOpacity>
        <Text style={styles.title}>InspireMe</Text>
      </View>

      <p className={isWide? 'subtitle subtitle-wide' : 'subtitle'}>
        {t('common.nagativeWaste')}<br />
        <br />
        {t('common.makePositiveHabit')}<br />
        <br />
        {t('common.applicationShort1')}
        {!isWide && <br /> }
        {t('common.applicationShort2')}
      </p>

      <div className={isWide ? "head-download-wrap head-download-wrap-wide" : "head-download-wrap"}>
        <a href={iosLink} onClick={onClickIosDownload} rel="noopener" target="_blank">
          <img
            className={isWide? 'download-btn download-btn-wide download-btn-apple-wide' : 'download-btn download-btn-apple'}
            src={t('common.downloadIosBtn')}
            alt='apple-store'
          />
        </a>

        <a href={androidLink} onClick={onClickAndroidDownload} rel="noopener" target="_blank">
          <img
            className={isWide? 'download-btn download-btn-wide download-btn-google-wide' : 'download-btn download-btn-google'}
            src={t('common.downloadAndroidBtn')}
            alt='google-store'
          />
        </a>
      </div>

      {/* 動画 */}
      <div id='video-area-over'></div>
      <div id="video-area">
        {!isVideoLoaded && (
          <Image
            defaultSource={'./assets/img/top/main.png'}
            resizeMode='cover'
            style={{height: '100%'}}
          />
        )}
        <ReactPlayer
          ref={videoRef}
          className='video'
          url={videoUrl}
          width='177.77777778vh'
          height={videoHeight}
          playing={isPlayVideo}
          loop={true}
          muted={true}
          onReady={handleVideoReady}
          onPause={onPause}
        />
      </div>
    </header>
  );
}



export default HpTopHead;
